import { MAX_PAGE_SIZE } from "@miplatform/constants";
import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ASSIGNMENTS = `${TASK_SERVICE}/assignments`;

export const assignments = {
  getOrderAssignments: async ({
    date = "",
    top = MAX_PAGE_SIZE,
    headers = {},
    toastMessageConfig = {},
  } = {}) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENTS}/order-assignments`,
      method: "get",
      headers: { ...headers, [X_API_VERSION]: API_VERSION },
      top,
      query: { date },
    });
    return apiRequest(options, toastMessageConfig);
  },
  assign: async ({ assignmentId, data, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENTS}/${assignmentId}/assign`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION, "if-match": modifiedOn },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  unassign: async ({ assignmentId, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENTS}/${assignmentId}/unassign`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION, "if-match": modifiedOn },
    });

    return apiRequest(options, toastMessageConfig);
  },
  publish: async ({
    assignmentId,
    modifiedOn,
    publishedOn = new Date().toISOString(),
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENTS}/${assignmentId}/publish`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION, "if-match": modifiedOn },
      data: { publishedOn },
    });

    return apiRequest(options, toastMessageConfig);
  },
  submitStepResult: async ({
    assignmentId,
    attemptId,
    stepId,
    stepResultId,
    data,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENTS}/${assignmentId}/attempts/${attemptId}/steps/${stepId}/step-results/${stepResultId}/submit`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  updateStepResult: async ({
    assignmentId,
    attemptId,
    stepId,
    data,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENTS}/${assignmentId}/attempts/${attemptId}/steps/${stepId}/step-results/upsert`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
};
